import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-play-fill text-background-50 text-lg"></i>
            </div>
            <span className="font-heading text-lg font-bold text-foreground-950 whitespace-nowrap">
              91视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-600 bg-primary-100'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 5).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-600 bg-primary-100'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-600 bg-primary-100'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3">
          <div className="flex flex-col gap-1">
            <Link to="/" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 whitespace-nowrap">首页</Link>
            {categories.map((cat) => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 whitespace-nowrap">
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 whitespace-nowrap">关于我们</Link>
          </div>
        </div>
      )}
    </nav>
  );
}